export default __webpack_public_path__ + "static/media/NotoSans-Medium.a4c42b7a.ttf";